/* React Components */
import React from 'react';
/* Providers */
import { useAuth } from '../../context/AuthContext';
/* Components */
import AdminSideBar from '../../components/AdminSideBar';
import CommonQuestionsTable from './components/CommonQuestionsTable';
import CustomPieChart from './components/CustomPieChart';
import CustomWidgets from './components/CustomWidgets';
import LatestUsersList from './components/LatestUsersList';
import RecentLoggedInUsers from './components/RecentLoggedInUsers';

const AdminDashboard = () => {
    /* User Information */
    const { userTheme } = useAuth();
    
    return (
        <section className={`chat-body-container admin-section-container ${userTheme}`}>
            {/* Sidebar */}
            <AdminSideBar />
            <div className="admin-dashboard-content">
                <div className="chat-box-top-container">
                    <a href="/admin/dashboard" className='chat-heading-container'>
                        <span>Dashboard</span>
                    </a>
                </div>

                
                {/* Dashboard Details */}
                <div className={`dbmm-dashboard-container ${userTheme}`}>
                    <div className="dbmm-dashboard-grid">
                        <div className="mm-row">
                            <div className="mm-col-xs-12 mm-col-md-6 mm-col-lg-8">
                                <CustomWidgets />
                            </div>
                            <div className="mm-col-xs-12 mm-col-md-6 mm-col-lg-4">
                                <CustomPieChart />
                            </div>
                        </div>
                        
                        <LatestUsersList />
                        <CommonQuestionsTable />
                        <RecentLoggedInUsers />
                    </div>

                    
                </div>
            </div>
        </section>
    );
};

export default AdminDashboard;